'use client'
import { useContext } from 'react'
import { AuthContext } from '@/root/shared-providers'

export const useGetAuthToken = () => {
  const { isAuth, token } = useContext(AuthContext)
  return { isAuth, token }
}
